var dd = require('react-dd');
var _ = require('lodash');

var esUtils = require('../../../../utils/esUtils');

module.exports = dd.createClass({
	getInitialState: function(){
		var today = new Date();
		if(_.isDate(this.props.value)){
			today = this.props.value;
		}else{
			var field = this.props.field;
			var start = _.isDate(field.valid_range && field.valid_range.start) ? field.valid_range.start : null;
			var stop = _.isDate(field.valid_range && field.valid_range.stop) ? field.valid_range.stop : null;
			if(start && ((start.getFullYear() > today.getFullYear()) || (start.getMonth() > today.getMonth()))){
				today = start;
			}else if(stop && ((stop.getFullYear() < today.getFullYear()) || (stop.getMonth() < today.getMonth()))){
				today = stop;
			}
		}
		return {
			year: today.getFullYear(),
			month: today.getMonth() + 1
		};
	},
	__incMonth: function(inc){
		var year = this.state.year;
		var month = this.state.month;
		var d = new Date(year, month - 1, 1);
		d.setMonth(d.getMonth() + inc);
		this.setState({year: d.getFullYear(), month: d.getMonth() + 1});
	},
	__nextMonth: esUtils.wrapPreventDefault(function(){
		this.__incMonth(1);
	}),
	__prevMonth: esUtils.wrapPreventDefault(function(){
		this.__incMonth(-1);
	}),
	__onDayClick: function(day){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			var year = self.state.year;
			var month = self.state.month;
			self.props.onDatePicked(year, month, day);
		});
	},
	render: function(){
		var self = this;
		var field = self.props.field;
		var year = self.state.year;
		var month = self.state.month;
		var selected_day = getDayIfMatches(self.props.value, month, year);

		var start_day = getDayIfMatches(field.valid_range && field.valid_range.start, month, year);
		var stop_day = getDayIfMatches(field.valid_range && field.valid_range.stop, month, year);

		var weeks = esUtils.build_calendar_weeks(year, month, true);
		return dd.div({className: 'DatePickerCalendar'},
			dd.table(null,
				dd.thead(null,
					dd.tr(null,
						dd.th({colSpan: 7, className: 'month'},
							start_day > 0 ? null : dd.button({className: 'btn btn-default btn-sm pull-left', onClick: this.__prevMonth},
								dd.i({className: 'fa fa-angle-left'})
							),
							esUtils.get_month_name(month) + ' ' + year,
							stop_day > 0 ? null : dd.button({className: 'btn btn-default btn-sm pull-right', onClick: this.__nextMonth},
								dd.i({className: 'fa fa-angle-right'})
							)
						)
					),
					dd.tr(null,
						_.map([1, 2, 3, 4, 5, 6, 7], function(d){
							return dd.th({key: d, className: 'dow'}, esUtils.get_day_of_week(d, true));
						})
					)
				),
				dd.tbody(null,
					_.map(weeks, function(week, i){
						return dd.tr({key: i},
							_.map(week, function(day, i){
								var classes = [];
								var onClick = null;
								if(day.out_of_month || day.date < start_day || (stop_day > 0 && day.date > stop_day)){
									classes.push('out');
								}else{
									classes.push('clickable');
									onClick = self.__onDayClick(day.date);
									if(day.date == selected_day){
										classes.push('selected');
									}
								}
								return dd.td({key: i},
									dd.span({className: classes.join(' '), onClick: onClick}, day.date)
								);
							})
						);
					})
				)
			)
		);
	}
});


var getDayIfMatches = function(date, month, year){
	if(_.isDate(date)){
		if(date.getFullYear() === year && date.getMonth() + 1 === month){
			return date.getDate();
		}
	}
	return -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Date/DatePickerCalendar.js
// module id = 195
// module chunks = 0 1 2 3 4